export const VideoPlayerConfig = {
    getVideoElement: async (player) => {
        return player;
    },
};
